import { Injectable } from '@angular/core';
import { DefaultDataServiceConfig, Logger } from '@ngrx/data';
import { HttpClient } from '@angular/common/http';
import { AbstractDataServiceV2 } from 'src/app/modules/core/service/v2/dataservice/abstractDataServiceV2';
import { CustomizeHttpUrlGenerator } from 'src/app/store/core/url/customizeHttpUrlGenerator';
import { DeviceDefinitionModel } from '../../../api/entity/deviceDefinition.model';
import { DeviceDefinitionConverter } from '../../../api/entity/converter/deviceDefinition.converter';

@Injectable({
  providedIn: 'root'
})
export class DeviceDefinitionDataService extends AbstractDataServiceV2<DeviceDefinitionModel, DeviceDefinitionConverter> {
  constructor(
    http: HttpClient,
    httpUrlGenerator: CustomizeHttpUrlGenerator,
    logger: Logger,
    config: DefaultDataServiceConfig,
    converter: DeviceDefinitionConverter
  ) {
    super('MedicalDeviceDefinition', http, httpUrlGenerator, logger, config, converter);
  }
}

